import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../utils/api';
import { FileText, Loader2, Upload } from 'lucide-react';

export default function Matches() {
  const [matches, setMatches] = useState([]);
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [teamFilter, setTeamFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState('');

  const load = () => {
    setLoading(true);
    const query = {};
    if (teamFilter) query.team_id = teamFilter;
    if (statusFilter) query.status = statusFilter;
    Promise.all([api.getMatches(query), api.getTeams()])
      .then(([m, t]) => { setMatches(m.matches || []); setTeams(t.teams || []); })
      .finally(() => setLoading(false));
  };

  useEffect(load, [teamFilter, statusFilter]);

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-8">
        <div>
          <h1 className="text-3xl font-bold text-navy-900">Matches</h1>
          <p className="text-gray-500 mt-1">Every match your organization has recorded.</p>
        </div>
        <Link to="/upload" className="flex items-center gap-2 bg-navy-900 hover:bg-navy-800 text-white font-medium px-5 py-2.5 rounded transition-colors">
          <Upload className="w-4 h-4" /> New Analysis
        </Link>
      </div>

      <div className="flex flex-wrap gap-3 mb-6">
        <select value={teamFilter} onChange={(e) => setTeamFilter(e.target.value)}
          className="border border-gray-300 rounded-lg px-3 py-2 text-sm">
          <option value="">All teams</option>
          {teams.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
        </select>
        <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}
          className="border border-gray-300 rounded-lg px-3 py-2 text-sm">
          <option value="">All statuses</option>
          <option value="Draft">Draft</option>
          <option value="Report ready">Report ready</option>
        </select>
      </div>

      {loading ? (
        <div className="text-center py-24"><Loader2 className="w-6 h-6 animate-spin mx-auto text-gray-500" /></div>
      ) : matches.length === 0 ? (
        <div className="text-center py-16 bg-white rounded-2xl border border-gray-200">
          <FileText className="text-gray-400 w-12 h-12 mx-auto mb-4" />
          <p className="text-gray-500">No matches match these filters.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {matches.map((match) => (
            <Link key={match.id} to={`/analysis/${match.id}`}
              className="flex items-center justify-between bg-white border border-gray-200 rounded-2xl p-4 hover:border-navy-300 transition-colors">
              <div>
                <p className="text-navy-900 font-medium">{(match.our_team_name || match.team_name)} vs {(match.opponent_name || match.opponent)}</p>
                <p className="text-gray-500 text-sm">
                  {match.match_date || 'No date'} · {match.competition || 'Friendly'} · {match.tactical_focus}
                </p>
              </div>
              <div className="text-right">
                {match.final_score && <p className="text-navy-900 font-semibold">{match.final_score}</p>}
                <p className="text-gray-400 text-xs mt-0.5">{match.status}</p>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
